<!-- 固定底部 -->
<template>
  <div
    class='fixed_footer'
    :style="{
      backgroundColor: `${options.style.bgType === 'color' ? options.style.bgColor : 'unset'}`,
      backgroundImage: `${options.style.bgType === 'image' ? 'url('+options.style.bgImg+')' : 'unset' }`,
      height: `${options.style.wrapHeight ? options.style.wrapHeight + 'px' : 'unset'}`,
      padding: `${'0px'} ${options.style.paddingLeft ? options.style.paddingLeft + 'px' : '16px'}`,
      gap: `${options.style.gap ? options.style.gap + 'px' : '0px'}`
    }"
  >
    <div class="footer_left">
      <div
        class="footer_inner"
        :style="{
          gridColumnGap:`${options.style.gridColumnGap ? options.style.gridColumnGap + 'px' : '20px'}`
        }"
      >
        <div
          class="footer_nav_item_wrap"
          v-for="element in options.info.left"
          :key="element.id"
          @click="handleClickNavItem(element)"
          :style="{
            width: `${options.style.nodeWidth ? options.style.nodeWidth : '100%'}`,
            height: `${options.style.nodeHeight ? options.style.nodeHeight  : '100%'}`
          }"
        >
          <div
            class="footer_nav_item"
            :style="{
              backgroundColor: `${element.style.bgType === 'color' ? element.style.bgColor: ''}`,
              backgroundImage: `url(${element.style.bgType === 'image' ? encodeURI(element.style.bgImg): ''})`,
            }"
          >
            <div
              class="footer_nav_item_icon"
              :class="element.icon.name"
              v-show="element.icon.show"
              :style="`color:${element.icon.color}`"
            ></div>
            <div
              class="footer_nav_item_text"
              v-show="element.text.show"
              :style="`color:${element.text.color}`"
            >
              {{ element.text.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="footer_center"
      v-show="options.info.center.icon.show"
    >
      <div
        class="footer_nav_item_wrap"
        @click="handleClickNavItem(options.info.center)"
      >
        <div
          class="footer_nav_item"
          :style="{
              backgroundColor: `${options.info.center.style.bgType === 'color' ? options.info.center.style.bgColor: ''}`,
            }"
        >
          <div
            class="footer_nav_item_icon"
            :style="{
              width: '26px',
              height: '26px'
            }"
          >
            <!-- :src="centerInfo.image" -->
            <img
              :src="options.info.center.style.bgImg"
              alt=""
              class="footer_nav_home_img"
            >
          </div>
          <div
            class="footer_nav_item_text"
            v-show="options.info.center.text.show"
            :style="`color:${options.info.center.text.color}`"
          >
            {{ options.info.center.text.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="footer_rigt">
      <div
        class="footer_inner"
        :style="{
          gridColumnGap:`${options.style.gridColumnGap ? options.style.gridColumnGap + 'px' : '20px'}`
        }"
      >
        <div
          class="footer_nav_item_wrap"
          v-for="element in options.info.right"
          :key="element.id"
          @click="handleClickNavItem(element)"
          :style="{
            width: `${options.style.nodeWidth ? options.style.nodeWidth : '100%'}`,
            height: `${options.style.nodeHeight ? options.style.nodeHeight  : '100%'}`
          }"
        >
          <div
            class="footer_nav_item"
            :style="{
              backgroundColor: `${element.style.bgType === 'color' ? element.style.bgColor: ''}`,
              backgroundImage: `url(${element.style.bgType === 'image' ? encodeURI(element.style.bgImg): ''})`,
            }"
          >
            <div
              class="footer_nav_item_icon"
              :class="element.icon.name"
              v-show="element.icon.show"
              :style="`color:${element.icon.color}`"
            ></div>
            <div
              class="footer_nav_item_text"
              v-show="element.text.show"
              :style="`color:${element.text.color}`"
            >
              {{ element.text.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => { }
    }
  },
  name: 'WebFixedFooter',
  data() {
    return {
      leftList: [],
      rightList: [],
      editPosition: 'left'
    };
  },

  watch: {},

  components: {},

  methods: {
    // 点击跳转
    handleClickNavItem(item) {
      if (item.url.length > 0) {
        window.location.href = item.url
      } else {
        this.$notify({
          type: 'warning',
          message: '敬请期待',
        })
      }
    },
  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.fixed_footer {
  width: 100%;
  // height: 60px;
  display: grid;
  grid-template-columns: 2fr 1fr 2fr;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  // padding: 0px 16px;
  box-sizing: border-box;
  .footer_left,
  .footer_rigt {
    .footer_inner {
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-content: center;
      justify-items: center;
      align-content: center;
      align-items: center;
      // gap: 20px;
      .footer_nav_item_wrap {
        width: 100%;
        height: 100%;
        cursor: pointer;
        .footer_nav_item {
          width: 100%;
          height: 100%;
          font-size: 14px;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          .footer_nav_item_icon {
            margin-bottom: 2px;
            font-size: 26px;
          }
          .footer_nav_item_text {
            font-size: 12px;
            line-height: 14px;
            text-align: center;
            word-break: keep-all;
          }
        }
      }
    }
  }
  .footer_center {
    .footer_nav_item_wrap {
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: 1fr;
      justify-content: center;
      justify-items: center;
      align-content: center;
      align-items: center;
      cursor: pointer;
      .footer_nav_item {
        width: 100%;
        height: 100%;
        font-size: 14px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        .footer_nav_item_icon {
          margin-bottom: 4px;
          // font-size: 26px;
          position: relative;
          .footer_nav_home_img {
            position: absolute;
            width: 40px;
            bottom: 5px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .footer_nav_item_text {
          font-size: 10px;
          // line-height: 14px;
          text-align: center;
          word-break: keep-all;
        }
      }
    }
  }
}
</style>